module.exports = __webpack_public_path__ + "static/img/8en.865dc8a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/desc/02keepAlive/vivo/8en.png
// module id = Uv8O
// module chunks = 0